(function () {
  const items = document.querySelectorAll('[data-reveal], .reveal');
  if (!items.length) return;

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      const delay = el.getAttribute('data-delay');
      if (delay) el.style.transitionDelay = `${delay}ms`;

      el.classList.add('is-revealed');
      obs.unobserve(el);
    });
  }, { threshold: 0.15 });

  items.forEach((el) => io.observe(el));
})();
/* =========================
   Global: Intacto Reveal Observer (site-wide)
   Paste at bottom of assets/global.js
   ========================= */
(function(){
  const prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced) {
    document.querySelectorAll('.s-reveal').forEach(el => el.classList.add('is-inview'));
    return;
  }

  function observeReveals(){
    const items = document.querySelectorAll('.s-reveal:not(.is-inview)');
    if (!items.length) return;

    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.14 });

    items.forEach(el => io.observe(el));
  }

  // Run once on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeReveals);
  } else {
    observeReveals();
  }

  // Shopify Theme Editor: when sections reload, re-observe
  document.addEventListener('shopify:section:load', observeReveals);
})();
